<template>
  <div
    class="map-footer"
    :class="{ dark }">

    <!-- subtitles -->
    <div
      v-if="setting('sub') && currentText"
      class="subtitles-wrapper">
      <Subtitles
        :text="currentText" />
    </div>

    <!-- itinerary -->
    <RouteButton
      @bbox="bbox"/>

    <!-- mini player -->
    <SpeechPlayer />

    <!-- user position and tracking -->
    <GeoBtn />

    <div
      class="map-footer-content">
      <div
        v-show="showDiscover"
        @click="clickDiscover">
        <PlayerProgress
          v-if="markerSpeech"
          :title="markerSpeech.title"
          :subtitle="playlistSubtitle"
          :progress="playlistProgress" />
        <div
          v-else
          class="map-discover">
          <div
            class="map-discover-content">
            <div
              class="map-discover-loading"
              v-if="markersLoading">
              <f7-preloader />
            </div>
            {{ t('footerDiscover') }}
          </div>
        </div>
      </div>

      <SwiperTitles
        v-show="!showDiscover" />

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GeoBtn from '@/components/io/GeoBtn'
import SwiperTitles from '@/components/hl/SwiperTitles'
import RouteButton from '@/components/io/RouteButton'
import SpeechPlayer from '@/components/hl/SpeechPlayer'
import PlayerProgress from '@/components/ui/Player/PlayerProgress'
import Subtitles from '@/components/ui/Subtitles'

export default {
  name: 'MapFooter',
  components: {
    RouteButton,
    SpeechPlayer,
    SwiperTitles,
    PlayerProgress,
    Subtitles,
    GeoBtn
  },
  props: {
    opened: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      markers: 'global/markers',
      swiper: 'global/swiper',
      markersLoading: 'global/markersLoading',
      highlight: 'global/highlight',
      playlistTitle: 'speech/playlistTitle',
      playlistSubtitle: 'speech/playlistSubtitle',
      playlistProgress: 'speech/playlistProgress',
      playlist: 'speech/playlist',
      currentText: 'speech/currentText',
      geoActive: 'global/geoActive',
      geoPos: 'global/geoPos',
      markerSpeech: 'speech/markerSpeech'
    }),
    follow () {
      return this.setting('follow')
    },
    showDiscover () {
      if (this.opened && !this.swiper.length) return true
      if (!this.opened) return true
      return false
    }
  },
  methods: {
    ...mapActions({
      geoStart: 'global/geoStart',
      setHighlight: 'global/setHighlight',
      setFlyTo: 'global/setFlyTo'
    }),
    clickDiscover () {
      this.$emit('discover')
    },
    clickPlayerProgress () {
      this.$emit('open')
    },
    clickDetail () {
      if (this.highlight) {
        this.$f7.views.main.router.navigate('/article/' + this.highlight._id)
      }
    },
    trackPos () {
      if (this.geoPos) {
        this.setFlyTo(this.geoPos)
        // this.$refs.map.layer.flyTo(this.geoPos, 18)
      }
      this.geoStart().then(pos => {
        const center = [pos.latitude, pos.longitude]
        this.setFlyTo(center)
        // this.$refs.map.layer.flyTo(center, 18)
      })
    },
    bbox (bbox) {
      console.log(bbox)
      this.$emit('bbox', bbox)
    }
  }
}
</script>

<style lang="scss">
.subtitles-wrapper {
  display: block;
  position: absolute;
  top: -90px;
  transform: translate(0, -100%);
  left: 16px;
  right: 16px;
  text-align: center;
  pointer-events: none;
  height: min-content;
}

.map-footer {
  background: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  .player-progress {
    padding: 0 50px;
  }

  .fab-right-top,
  .fab-left-top {
    top: -70px !important;
  }

  .player-header {
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translate(-50%,-100%);
  }

  .map-footer-content {
    display: block;
    position: relative;
  }
  .map-discover {
    position: relative;
    text-align: center;
    line-height: 35px;
    padding: 10px 0 15px;
    color: var(--f7-navbar-large-title-text-color);
    &:before {
      display: block;
      content: '';
      position: absolute;
      top: 8px;
      left: 50%;
      transform: translate(-50%,0);
      width: 100px;
      height: 6px;
      border-radius: 3px;
      background: #e6e6e6;
    }
    .map-discover-content {
      position: relative;
      display: inline-block;
      line-height: 30px;
      padding: 0 30px;
      .map-discover-loading {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0,-50%);
      }
    }
  }
  &.dark {
    background: black;
    .map-discover {
      color: #666;
      &:before {
        background: #333;
      }
    }
  }
}
</style>
